import { Flex, Heading, List, Text } from "@wayflyer/flyui";

interface InfoSectionProps {
  heading?: string;
  bulletPoints?: boolean;
  content?: string[];
}

export const InfoSection = ({ heading, content, bulletPoints = false }: InfoSectionProps) => {
  return (
    <Flex direction="column" gap="3">
      {heading ? <Heading>{heading}</Heading> : null}
      {content ? (
        bulletPoints ? (
          <List>
            {content.map((item, index) => (
              <List.Item key={index}>{item}</List.Item>
            ))}
          </List>
        ) : (
          <Flex gap="2" direction="column">
            {content.map((item, index) => (
              <Text key={index}>{item}</Text>
            ))}
          </Flex>
        )
      ) : null}
    </Flex>
  );
};
